import { render, staticRenderFns } from "./RcPerformanceData.vue?vue&type=template&id=c1349da6&"
import script from "./RcPerformanceData.vue?vue&type=script&lang=js&"
export * from "./RcPerformanceData.vue?vue&type=script&lang=js&"
import style0 from "./RcPerformanceData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports